 

'use client';

import { useState } from 'react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Vui lòng nhập email');
      setStatus('error');
      return;
    }

    setStatus('loading');

    try {
      console.log('Submitting email:', email); // Logging để debug

      const response = await fetch('/api/blogs/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      // Kiểm tra nếu response không OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', response.status, errorText);
        throw new Error(`Status ${response.status}: ${errorText}`);
      }

      // Parse JSON nếu response có nội dung
      let data;
      const responseText = await response.text();
      if (responseText) {
        try {
          data = JSON.parse(responseText);
        } catch (parseError) {
          console.error('Failed to parse JSON:', responseText);
          throw new Error('Lỗi khi xử lý phản hồi từ server');
        }
      }

      setStatus('success');
      setEmail('');
      console.log('Success:', data);
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
      if (error instanceof Error) {
        setErrorMessage(error.message || 'Có lỗi xảy ra khi đăng ký');
      } else {
        setErrorMessage('Có lỗi xảy ra khi đăng ký');
      }
    }
  };

  return (
    <div className="rounded-lg border bg-white p-4 shadow-sm">
      <h3 className="mb-4 text-left text-lg font-semibold">Đăng ký nhận tin</h3>
      <p className="mb-4 text-left">
        Nhận thông báo khi có bài viết mới về quản lý nhà hàng và F&B
      </p>

      {status === 'success' ? (
        <div className="rounded-lg bg-green-100 p-4 text-left text-green-700">
          Đăng ký thành công! Cảm ơn bạn đã đăng ký nhận bản tin của chúng tôi.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email của bạn"
            className="w-full rounded-lg border border-primary-200 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-white/30"
            required
          />

          {status === 'error' && (
            <div className="text-sm text-red-500">{errorMessage}</div>
          )}

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full rounded-lg bg-primary-400 px-4 py-2 font-medium text-white transition-colors hover:bg-primary-300 disabled:opacity-70"
          >
            {status === 'loading' ? 'Đang xử lý...' : 'Đăng ký'}
          </button>
        </form>
      )}
    </div>
  );
}
